import { IsNorne } from "@portal/helpers/IsNorne";
import { useMemo } from "react";
import { NORNE_CENTERID } from "@portal/assets/banks";
import { IUseCenterId } from "./types";
import { useSession } from "@portal/auth/client/SessionProvider";

const useCenterId: IUseCenterId = () => {
  const { session } = useSession();

  const centerIdCalc = useMemo(() => {
    if (session?.status !== "authenticated") return undefined;
    if (session?.centerId === undefined) return undefined;
    if (IsNorne(session?.centerId)) return NORNE_CENTERID;
    return session?.centerId;
  }, [session?.centerId, session?.status]);

  return centerIdCalc;
};

export default useCenterId;
